<template>
  <div class="selection-header">
    <img id="basket-icon"
         :src="iconBasket"
         :draggable="false"
    />
    <DxCheckBox id="header-checkbox"
                v-model:value="selectAllState"
                :icon-size="18"
                @initialized="initializeCheckbox"
                @value-changed="checkboxClicked"
    />
  </div>
</template>

<script setup>
  import DxCheckBox from "devextreme-vue/check-box";
  import iconBasket from '@/images/BasketIcon.svg'
  import { storeToRefs } from "pinia";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";
  import { useCabinetStore } from "@/stores/cabinetStore.js";

  const searchPageStore = useSearchPageStore()
  const cabinetStore = useCabinetStore()
  const { selectAllState } = storeToRefs(searchPageStore)
  const { cabinetId } = storeToRefs(cabinetStore)

  const initializeCheckbox = () => {}
  const checkboxClicked = (e) => {
    // @value-changed picks up changes to the value coming in from exterior sources
    // we check if a user actually clicked to cause the event meaning a real change has occurred
    if (!e.event)
      return

    const newSelectedState = e.value
    searchPageStore.selectAll(newSelectedState, cabinetId.value)
  }
</script>

<style scoped lang="scss">
.selection-header {
  position: absolute;
  left: 21px;
  right: auto;
  display: flex;
  flex-direction: column;

  #basket-icon {
    height: 22px;
    max-width: 25px;
    position: absolute;
    left: -3.5px;
    margin: 0 auto;
  }

  #header-checkbox {
    position: absolute;
    top: 50px;
    z-index: 1;

    //.dx-checkbox-container {
      //display: flex;
      //justify-content: center;
    //}
  }
}
</style>
